import { Heading, Text } from '@components/ui/typography';
import { parse } from '@config/theme';
import { decodeAssetId } from '@lib/sanity/decode-asset-id';
import { blurImage, urlFor } from '@lib/sanity/url-for';
import Image from 'next/image';
import NextLink from 'next/link';
import React, { FC } from 'react';
import { BlogItem } from '__generated__/sanity';
import { parseDate } from './parse-date';
import { BlogTag, BlogTags } from './Tags';
export const BlogFeatured: FC<BlogItem['fields']> = ({
  preview,
  summary
}) => {
  const {
    dimensions
  } = decodeAssetId(preview.image.asset._ref);
  return <NextLink href={`/blog/${summary.urlSlug.current}`} className={grid}>
      <div data-content="" className={content}>
        <Text variant="bodyLarge" color="shade500" fontWeight="bold" mb={{
        _: '2',
        sm: '4'
      }}>
          Featured • {parseDate(summary.date)}
        </Text>
        <Heading as="h2" variant="h4" mb="6">
          {summary.summaryTitle}
        </Heading>
        <Text variant="bodyLarge" color="shade500" mb={{
        _: '4',
        sm: '24'
      }}>
          {preview.subtitle}
        </Text>
        {summary.tags && summary.tags.length && <BlogTags>
            {summary.tags.map(tag => <BlogTag key={tag}>{tag}</BlogTag>)}
          </BlogTags>}
        <Text variant="bodyRegular" color="purpleWeb">
          Read post
        </Text>
      </div>
      <Image src={urlFor(preview.image).toString()} layout="responsive" alt="" width={dimensions.width * 0.75} height={dimensions.height * 0.75} data-image="" blurDataURL={blurImage(preview.image)} placeholder="blur" />
    </NextLink>;
};
const grid = parse({
  display: 'grid',
  pb: {
    _: '64'
  },
  mb: {
    _: '64'
  },
  alignItems: 'center'
}, "g1ki1mbj");
const content = parse({
  pt: {
    _: '4',
    sm: '0'
  },
  pr: {
    sm: '4'
  }
});

require("./Featured.linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Featured.tsx");